import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

export function PageLoader() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
      }}
    >
      <Spin size="large" indicator={<LoadingOutlined spin />} />
    </div>
  );
}
